import { Link } from "react-router-dom";
import { AuthShell } from "../components/AuthShell";
import { SeoForPage } from "../components/Seo";
import { useT, useLp } from "../lib/i18n";

/**
 * User backed out of Stripe Checkout. Stripe redirects here with no
 * session_id — we just reassure them nothing was charged and offer a quick
 * way back into the Pricing page to retry.
 */
export function BillingCancelled() {
  const t = useT();
  const lp = useLp();
  const tc = t.billing.cancelled;

  return (
    <AuthShell>
      <SeoForPage page="billingCancelled" noindex />
      <div className="text-center">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-margin text-ink/60 dark:bg-paper/10 dark:text-paper/60">
          <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
            <line x1="5" y1="5" x2="15" y2="15" />
            <line x1="15" y1="5" x2="5" y2="15" />
          </svg>
        </div>

        <h1 className="mt-6 font-display text-3xl font-semibold tracking-tight text-ink dark:text-paper">
          {tc.heading}
        </h1>
        <p className="mt-3 text-sm text-ink/60 dark:text-paper/60">
          {tc.sub}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
          <Link
            to={lp + "/#pricing"}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-graphite text-paper hover:bg-graphite-muted transition-colors px-6 py-3 text-sm font-medium"
          >
            {tc.retryCta}
          </Link>
          <Link
            to={lp + "/"}
            className="inline-flex items-center justify-center rounded-full border border-ink/20 dark:border-paper/30 px-6 py-3 text-sm font-medium text-ink dark:text-paper hover:bg-ink/5 dark:hover:bg-paper/5 transition-colors"
          >
            {tc.homeCta}
          </Link>
        </div>
      </div>
    </AuthShell>
  );
}
